import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";

function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/forgot-password`, { username });
      setMessage(response.data.message);
      setIsError(false);
    } catch (error) {
      setMessage(error.response?.data?.message || "Server error");
      setIsError(true);
    }
  };

  return (
    <div className="login-container">
      <div className="left-section">
        <img src="/assets/logo/inypeople_logo.png" alt="Logo" className="logo" />
        <div className="left-content">
          <h1>Forgot Password?</h1>
          <p>Enter username to get reset link</p>
          <div className="line"></div>
          <img src="/assets/images/login_img.png" alt="Illustration" className="illustration" />
        </div>
      </div>

      <div className="right-section">
        <div className="form-box">
          <h2>Reset Password</h2>
          <p className="sub-text">
            Enter your username — we'll send a reset link to your registered email
          </p>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>User Name</label>
              <div className="input-box">
                <span className="icon">
                  <img src="/assets/images/log-user.png" alt="user" className="input-icon" />
                </span>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="signin-btn">
              Send Reset Link
            </button>
          </form>

          {message && (
            <p className="login-message"
              style={{ color: isError ? "red" : "green", marginTop: "15px" }}>
              {message}
            </p>
          )}

          <div
            onClick={() => navigate("/admin/login")}
            style={{ cursor: "pointer", textAlign: "center", 
                     marginTop: "15px", color: "#1a237e" }}>
            ← Back to Login
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;